module.exports = __webpack_public_path__ + "img/prius.8e8671a6.png";